// Shared "card with arrow" visual — root style reused by the header's popovers (DownloadCenterPopover, UserMenuPopover).
const popoverCardStyles = {
  padding: '15px',
  position: 'relative',
  borderRadius: '4px',
  background: 'white',
  minWidth: 260,
  boxShadow: '0px 3px 14px 2px rgba(0, 0, 0, 0.12), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 5px 5px -3px rgba(0, 0, 0, 0.20)',
  '&::before': {
    backgroundColor: 'white',
    content: '""',
    display: 'block',
    position: 'absolute',
    width: 12,
    height: 12,
    top: '-6px',
    transform: 'rotate(45deg)',
    right: '6px'
  }
};

export default popoverCardStyles;
